/**
 * PurchaseCommentHistoriesModalCtrl — show purchase internal comment change history (paged)
 */

/* @ngInject */
export default function PurchaseCommentHistoriesModalCtrl ($uibModalInstance, purchase, purchaseNumber) {
  const vm = this
  vm.histories = []
  vm.purchaseNumber = purchaseNumber
  vm.historyLoaded = false
  vm.historyEmpty = false
  vm.dismiss = $uibModalInstance.dismiss

  vm.getCommentHistories = function (tableState) {
    vm.historyLoaded = false
    purchase._commentHistories(tableState)
      .then(function (result) {
        vm.histories = result.content || []
        vm.historyLoaded = true
        vm.historyEmpty = vm.histories.length === 0
      })
      .catch(function () {
        vm.histories = []
        vm.historyLoaded = true
        vm.historyEmpty = true
      })
  }

  vm.hasOldComment = function (row) {
    if (row == null || typeof row !== 'object') {
      return false
    }
    var v = row.oldComment
    return v !== null && v !== undefined && v !== ''
  }

  /** Curly quotes, same pattern as subscriber note updates. */
  vm.quoted = function (text) {
    if (text === null || text === undefined || text === '') {
      return ''
    }
    return '\u201C' + text + '\u201D'
  }
}
